function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon/Big/HighSun"
}, React.createElement("g", {
  id: "Group 12"
}, React.createElement("path", {
  id: "Combined Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.1139 12.4051H35.8861V0H34.1139V12.4051ZM35 17.7215C25.9611 17.7215 18.6076 25.0751 18.6076 34.1139C18.6076 43.1528 25.9611 50.5063 35 50.5063C44.0389 50.5063 51.3924 43.1528 51.3924 34.1139C51.3924 25.0751 44.0389 17.7215 35 17.7215ZM35 52.2785C24.9838 52.2785 16.8354 44.1301 16.8354 34.1139C16.8354 24.0977 24.9838 15.9494 35 15.9494C45.0162 15.9494 53.1646 24.0977 53.1646 34.1139C53.1646 44.1301 45.0162 52.2785 35 52.2785ZM35.8861 57.5949V70H34.1139V57.5949H35.8861ZM0 35.8861H12.4051V34.1139H0V35.8861ZM70 35.8861H57.5949V34.1139H70V35.8861ZM19.2825 18.7634L10.5113 9.9921L11.7642 8.73919L20.5354 17.5105L19.2825 18.7634ZM51.237 50.7178L60.0083 59.4891L61.2612 58.2362L52.4899 49.4649L51.237 50.7178ZM10.8778 59.4891L9.62491 58.2362L18.3962 49.4649L19.6491 50.7178L10.8778 59.4891ZM50.3506 17.5105L51.6036 18.7634L60.3748 9.9921L59.1219 8.73919L50.3506 17.5105Z",
  fill: "#6E6E6E"
})));

var SvgHighSun = function SvgHighSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHighSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/high-sun.d59abc65.svg";
export { ForwardRef as ReactComponent };